import Logger from "@cappelendamm/logger";
import { getContractData } from "../selectors/getContractData.js";
import { signUpSubscriptionContract } from "../../subscription-contract/index.js";
import { getSubscriptionProduct } from "../../subscription-product/index.js";
// Sign up a subscription contract from an imported row
export const signUpImportedContract = async (importId, input, { client, dataFactoryClient, }) => {
    Logger.log(`[import] START signUpImportedContract importId="${importId}"`);
    // Sku is required, and next_isbn for everything but book clubs
    try {
        if (!input?.sku) {
            const message = `Missing SKU for import id: ${importId}`;
            Logger.error(`[import] ${message}`);
            return { success: false, importId, message };
        }
        // Load subscription product metadata
        const product = await getSubscriptionProduct({ sku: input.sku }, { client });
        Logger.log(`[import] Product loaded (sku="${input.sku}", isSeries=${!!product?.isSeries}) importId="${importId}"`);
        // Map import row to contract creation input
        const contractInput = getContractData(input, product);
        Logger.log(`[import] contractInput built (productSku="${contractInput?.product?.sku}", plan="${contractInput?.product?.planIdentifier}", hasCustomer=${!!contractInput?.customer}, hasFreight=${!!contractInput?.freight})`);
        let selectedBookSku;
        if (!product.isBookClub) {
            if (!input?.next_isbn) {
                const message = `Missing next ISBN for import id: ${importId}`;
                Logger.error(`[import] ${message}`);
                return { success: false, importId, message };
            }
            // For series: find the selected book (by ISBN) to start at
            const selectedBook = product.series?.products?.find((book) => book.isbnean === input.next_isbn);
            selectedBookSku = selectedBook?.sku;
            if (!selectedBookSku) {
                const message = `Could not find a book matching ISBN ${input.next_isbn} (missing sku) for import id: ${importId}`;
                Logger.error(`[import] ${message}`);
                return { success: false, importId, message };
            }
        }
        // Create the subscription contract (import mode)
        Logger.log(`[import] Calling signUpSubscriptionContract importId="${importId}" selectedBookSku="${selectedBookSku}"`);
        const { contractId } = await signUpSubscriptionContract(contractInput, { isImported: true }, {
            client,
            dataFactoryClient,
        }, selectedBookSku, importId);
        Logger.log(`[import] OK signUpSubscriptionContract ➜ contractId="${contractId}" (importId="${importId}")`);
        // Final success envelope
        Logger.log(`[import] DONE import OK (contractId="${contractId}", importId="${importId}")`);
        return {
            success: true,
            importId,
            message: contractId
                ? `Subscription ${contractId} created successfully.`
                : "Subscription created successfully.",
        };
    }
    catch (e) {
        // Hard failure: surface message for the importer UI/logs
        const message = e?.message ??
            `Unknown error during signUpImportedContract (importId="${importId}")`;
        Logger.error(`[import] ERROR importId="${importId}"`, e);
        return { success: false, importId, message };
    }
};
